import React, { useState, useRef, useEffect } from "react"
import { Box, Container, Heading, Flex } from "@theme-ui/components"
import ReferenceThumb from "../components/referenceThumb"
import { i18nContext } from "../context/i18nContext"

// Begin swiper
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import "swiper/css/grid"
import "swiper/css/pagination"
import { Grid, Pagination } from "swiper/modules"
import { InboundLink } from "../components/link"
import { getSingleReferencePath } from "../utils/path"
// End swiper

const ReferenceCollection = ({ block, subtitle, anchorText }) => {
  const [marginLeft, setMarginLeft] = useState(0)
  const customContainerRef = useRef()

  const { references } = block
  console.log(references)
  useEffect(() => {
    const handleResize = () => {
      if (customContainerRef.current)
        setMarginLeft(customContainerRef.current.getBoundingClientRect().left)
    }

    window.addEventListener("resize", handleResize)
    handleResize()

    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  return (
    <Box
      sx={{
        backgroundColor: "grey",
        ".swiper": {
          pb: [6],
        },
        ".swiper-container": {
          pb: [8],
        },
        ".swiper-wrapper": { alignItems: "stretch" },
        pt: [4, 9],
        pb: [4, 6],
      }}
    >
      <Container sx={{ py: [0, 0] }}>
        <Flex
          sx={{
            mb: [6, 7],
            flexDirection: ["column", "row"],
            alignItems: ["flex-start", "center"],
            justifyContent: ["flex-start", "space-between"],
          }}
        >
          <Heading
            as="h2"
            sx={{
              mb: [3, 0],
              fontWeight: [300],
              color: "dark",
              fontSize: [5],
            }}
          >
            {subtitle}
          </Heading>
          {anchorText && (
            <i18nContext.Consumer>
              {t => (
                <InboundLink to={getSingleReferencePath(t.locale)}>
                  {anchorText}
                </InboundLink>
              )}
            </i18nContext.Consumer>
          )}
        </Flex>
        <Swiper
          modules={[Grid, Pagination]}
          spaceBetween={30}
          pagination={{
            clickable: true,
          }}
          breakpoints={{
            320: {
              slidesPerView: 2,
              slidesPerGroup: 2,
              grid: {
                rows: 4,
                fill: "row",
              },
            },
            640: {
              slidesPerView: 3,
              slidesPerGroup: 3,
              grid: {
                rows: 4,
                fill: "row",
              },
            },
            896: {
              slidesPerView: 5,
              slidesPerGroup: 5,
              grid: {
                rows: 4,
                fill: "row",
              },
            },
          }}
        >
          {references.map(reference => (
            <SwiperSlide key={reference.id}>
              <ReferenceThumb reference={reference} small />
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </Box>
  )
}

export default ReferenceCollection
